import React, { Component, Alert, useState, xlsx } from "react";
import "./bulk-upload.styles.css";
import { selectUserData } from "../../redux/user/user.selectors";
import {
  Spin,
  Button,
  Typography,
  Row,
  Col,
  Card,
  Breadcrumb,
  Tag,
  Icon,
  Table,
  message,
  Badge,
  Modal,
} from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  Link,
  withRouter,
  Switch as RouteSwitch,
  Route,
} from "react-router-dom";

import API, { baseURL } from "../../api";
import moment from "moment";

import {
  setBranchName,
  setEntryNo,
  setScreenName,
  setScreenType,
} from "../../redux/arrival-entry/arrival-entry.actions";
import {
  selectScreenName,
  selectScreenType,
  selectUploadFile,
} from "../../redux/arrival-entry/arrival-entry.selectors";

/**
 * @component
 * @description The parent component for bulk upload page.
 *
 *
 */
class BulkUploadSummary extends Component {
  state = {
    isSpinnerOn: false,
    isSubmitted: false,
    tableData: [],
    cardData: [],
    invalidRecords: 0,
    submitAllowed: false,
    totalRecords: 0,
    validRecords: 0,
    warningRecords: 0,
  };
  async componentDidMount() {
    const { screenType, uploadfile, setScreenName, setEntryNo, setBranchName } =
      this.props;
    const confirm = Modal.confirm;
    if (uploadfile) {
      try {
        this.setState((prevState) => ({
          ...prevState,
          isSpinnerOn: true,
        }));
        const formData = new FormData();
        formData.append("file", uploadfile);
        const response = await API.post(
          screenType == "mandi"
            ? "/upload_arrival_mandi_excel"
            : "upload_arrival_for_excel",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        response.data.message && message.warning(response.data.message, 2.5);
        if (response.data.status == true && response.data.data) {
          const validationData = [
            ...response.data.data.errors.map((item, index) => ({
              ...item,
              key: `error-${index}`,
              type: "ERROR",
            })),
            ...response.data.data.warnings.map((item, index) => ({
              ...item,
              key: `warning-${index}`,
              type: "WARNING",
            })),
          ];
          this.setState((prevState) => ({
            ...prevState,
            tableData: validationData,
            invalidRecords: response.data.data.invalid_records,
            submitAllowed: response.data.data.submit_allowed,
            totalRecords: response.data.data.total_records,
            validRecords: response.data.data.valid_records,
            warningRecords: response.data.data.warning_records,
          }));
          setEntryNo(response.data.data.valid_records);
          setBranchName(response.data.data.branch_name);
        } else if (
          response.data.message?.includes(
            "Submission already completed for this branch today.",
          )
        ) {
          confirm({
            title: "Alert!!!",
            content: response.data.message,
            okText: "Ok",
            onOk() {
              setScreenName(1);
            },
            okButtonProps: {
              style: { background: "#0061a5" },
            },
            cancelButtonProps: {
              style: { display: "none" },
            },
          });
        }
      } catch (error) {
        console.log("error", error);
        setScreenName(1);
      } finally {
        this.setState((prevState) => ({
          ...prevState,
          isSpinnerOn: false,
        }));
      }
    }
  }
  render() {
    const { screenType, uploadfile, setScreenName } = this.props;
    const onSubmitUpload = async () => {
      if (uploadfile) {
        try {
          this.setState((prevState) => ({
            ...prevState,
            isSpinnerOn: true,
          }));
          const formData = new FormData();
          formData.append("file", uploadfile);
          formData.append("submit", true);
          const response = await API.post(
            screenType == "mandi"
              ? "/upload_arrival_mandi_excel"
              : "upload_arrival_for_excel",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          response.data.message && message.success(response.data.message, 2.5);
          this.setState((prevState) => ({
            ...prevState,
            isSpinnerOn: false,
          }));
          setScreenName(4);
        } catch (error) {
          this.setState((prevState) => ({
            ...prevState,
            isSpinnerOn: false,
          }));
          setScreenName(1);
        }
      }
    };
    return (
      <Spin spinning={this.state.isSpinnerOn} tip="Loading...">
        {screenType == "mandi" ? (
          <div
            className="summary-page-container"
            // style={{ height: window.innerHeight - 85 }}
          >
            <Breadcrumb
              separator={
                <Icon
                  type="right"
                  style={{ color: "#002045", fontSize: 10, fontWeight: 700 }}
                />
              }
              style={{ marginBottom: 10 }}
            >
              <Breadcrumb.Item>Arrival</Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => setScreenName(1)}>
                <a>Bulk Upload</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#002045", fontWeight: 500 }}>
                Bulk Upload Summary
              </Breadcrumb.Item>
            </Breadcrumb>
            <Typography.Title level={2} style={{ margin: 0, fontWeight: 700 }}>
              Mandi Upload Summary
            </Typography.Title>
            <Typography.Paragraph strong>
              Review the data integrity and validation results for the latest
              file upload.
            </Typography.Paragraph>
            <Row style={{ marginBottom: 10 }}>
              <Col span={8}>
                <Tag
                  color="blue"
                  style={{
                    paddingBlock: 5,
                    paddingInline: 15,
                    // border: "1px solid #c4c6cf",
                    borderRadius: 15,
                  }}
                >
                  <Icon
                    type="calendar"
                    style={{ color: "#0061a5", fontSize: 16, paddingRight: 10 }}
                  />
                  <Typography.Text>DATA UPLOADED FOR: </Typography.Text>
                  <Typography.Text strong>
                    {moment().format("MMMM DD, YYYY")}
                  </Typography.Text>
                </Tag>
              </Col>
              <Col offset={6} span={6} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    height: 40,
                    color: "#0061a5",
                    background: "#fff",
                    fontSize: 16,
                    fontWeight: 500,
                    border: "1px solid #0061a5",
                  }}
                  onClick={() => setScreenName(2)}
                >
                  <Icon type="upload" /> Re-Upload
                </Button>
              </Col>
              <Col span={4} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    background: "#0061a5",
                    color: "#fff",
                    fontWeight: 600,
                  }}
                  size="large"
                  onClick={onSubmitUpload}
                  disabled={!this.state.submitAllowed}
                >
                  <Icon
                    type="check-circle"
                    style={{
                      fontWeight: 600,
                    }}
                  />{" "}
                  Submit Data
                </Button>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginBottom: 40 }}>
              <Col span={6}>
                <Card style={{ border: "1px solid #c4c6cf", borderRadius: 10 }}>
                  <Row type="flex" align="bottom" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        TOTAL RECORDS
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="file-text"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#0061a5",
                        }}
                      />
                    </Col>
                    <Col span={24}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0 }}
                      >
                        {this.state.totalRecords}
                      </Typography.Title>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #c4c6cf",
                    borderLeft: "5px solid green",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="bottom" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        VALID ENTRIES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="check-circle"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "green",
                        }}
                      />
                    </Col>
                    <Col span={16}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0 }}
                      >
                        {this.state.validRecords}
                      </Typography.Title>
                    </Col>
                    <Col
                      span={8}
                      style={{ textAlign: "right", color: "green" }}
                    >
                      {!isNaN(
                        Number(this.state.validRecords) /
                          Number(this.state.totalRecords),
                      )
                        ? (
                            (Number(this.state.validRecords) /
                              Number(this.state.totalRecords)) *
                            100
                          ).toFixed(2)
                        : 0}
                      %
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #c4c6cf",
                    borderLeft: "5px solid orange",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="bottom" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        WARNING CASES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="warning"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "orange",
                        }}
                      />
                    </Col>
                    <Col span={16}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0 }}
                      >
                        {this.state.warningRecords}
                      </Typography.Title>
                    </Col>
                    <Col
                      span={8}
                      style={{ textAlign: "right", color: "orange" }}
                    >
                      {!isNaN(
                        Number(this.state.warningRecords) /
                          Number(this.state.totalRecords),
                      )
                        ? (
                            (Number(this.state.warningRecords) /
                              Number(this.state.totalRecords)) *
                            100
                          ).toFixed(2)
                        : 0}
                      %
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #c4c6cf",
                    borderLeft: "5px solid #ba1a1a",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="bottom" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        INVALID ENTRIES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="exclamation-circle"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#ba1a1a",
                        }}
                      />
                    </Col>
                    <Col span={16}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0, color: "#ba1a1a" }}
                      >
                        {this.state.invalidRecords}
                      </Typography.Title>
                    </Col>
                    <Col
                      span={8}
                      style={{ textAlign: "right", color: "#ba1a1a" }}
                    >
                      {!isNaN(
                        Number(this.state.invalidRecords) /
                          Number(this.state.totalRecords),
                      )
                        ? (
                            (Number(this.state.invalidRecords) /
                              Number(this.state.totalRecords)) *
                            100
                          ).toFixed(2)
                        : 0}
                      %
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Table
              columns={[
                {
                  title: "ROW",
                  dataIndex: "row",
                  render: (text) => (
                    <Typography.Title level={4}>#{text}</Typography.Title>
                  ),
                },
                {
                  title: "TYPE",
                  dataIndex: "type",
                  render: (type) => (
                    <Tag
                      color={type === "ERROR" ? "red" : "orange"}
                      style={{ border: 0, paddingInline: 10, borderRadius: 10 }}
                    >
                      <Icon
                        type={type === "ERROR" ? "close-circle" : "warning"}
                      />{" "}
                      {type}
                    </Tag>
                  ),
                },
                {
                  title: "FIELD CONTEXT ",
                  dataIndex: "context",
                },
                {
                  title: "VALIDATION MESSAGE",
                  dataIndex: "message",
                },
              ]}
              style={{ border: "1px solid #d9d9d9", borderRadius: 10 }}
              dataSource={this.state.tableData}
              rowClassName={(record) =>
                record.type === "ERROR" ? "error-row" : "warning-row"
              }
              title={() => {
                return (
                  <>
                    <Typography.Title level={4} style={{ paddingLeft: 20 }}>
                      Validation Details{" "}
                      <Tag color="#93000a">
                        {this.state.invalidRecords} ERRORS
                      </Tag>
                      <Tag color="rgb(255, 145, 0)">
                        {this.state.warningRecords} WARNINGS
                      </Tag>
                    </Typography.Title>
                  </>
                );
              }}
            />
            <Card
              style={{
                marginBlock: 20,
                background: "#f7fafc",
                color: "#0061a5",
              }}
            >
              <Card.Meta
                avatar={
                  <Icon
                    type="info-circle"
                    style={{ fontSize: 20, color: "#0061a5" }}
                  />
                }
                title="Upload Compliance Requirements"
                description={`Total errors (${this.state.invalidRecords}) must be resolved in the source Excel file before the 'Submit Data' action can be performed. Warnings (${this.state.warningRecords}) are for informational purposes but we recommend double-checking price outliers to maintain historical accuracy.`}
              />
            </Card>
          </div>
        ) : (
          <div
            className="summary-page-container"
            // style={{ height: window.innerHeight - 85 }}
          >
            <Breadcrumb
              separator={
                <Icon
                  type="right"
                  style={{ color: "#002045", fontSize: 10, fontWeight: 700 }}
                />
              }
              style={{ marginBottom: 10 }}
            >
              <Breadcrumb.Item>Arrival</Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => setScreenName(1)}>
                <a>Bulk Upload</a>
              </Breadcrumb.Item>
              <Breadcrumb.Item style={{ color: "#002045", fontWeight: 500 }}>
                Bulk Upload Summary
              </Breadcrumb.Item>
            </Breadcrumb>
            <Typography.Title level={2} style={{ margin: 0, fontWeight: 700 }}>
              FOR Upload Summary
            </Typography.Title>
            <Row style={{ marginBottom: 20 }}>
              <Col
                span={8}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Tag
                  color="#f7fafc"
                  style={{
                    paddingBlock: 5,
                    paddingInline: 15,
                    border: "1px solid #c4c6cf",
                    borderRadius: 15,
                  }}
                >
                  <Icon
                    type="calendar"
                    style={{ color: "#000", fontSize: 16, paddingRight: 10 }}
                  />
                  <Typography.Text>DATA UPLOADED FOR: </Typography.Text>
                  <Typography.Text strong>
                    {moment().format("MMMM DD, YYYY")}
                  </Typography.Text>
                </Tag>
                <Typography.Text>
                  Validation report for File:{" "}
                  <Typography.Text style={{ fontWeight: 700 }}>
                    {uploadfile?.name}
                  </Typography.Text>
                </Typography.Text>
              </Col>
              <Col offset={6} span={6} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    height: 40,
                    color: "#0061a5",
                    background: "#fff",
                    fontSize: 16,
                    fontWeight: 500,
                    border: "1px solid #0061a5",
                  }}
                  onClick={() => setScreenName(2)}
                >
                  <Icon type="reload" /> Re-Upload File
                </Button>
              </Col>
              <Col span={4} style={{ textAlign: "right" }}>
                <Button
                  style={{
                    background: "#0061a5",
                    color: "#fff",
                    fontWeight: 600,
                  }}
                  size="large"
                  onClick={onSubmitUpload}
                  disabled={!this.state.submitAllowed}
                >
                  <Icon
                    type="check-circle"
                    style={{
                      fontWeight: 600,
                    }}
                  />{" "}
                  Submit Data
                </Button>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginBottom: 40 }}>
              <Col span={6}>
                <Card style={{ border: "1px solid #c4c6cf", borderRadius: 10 }}>
                  <Row type="flex" align="middle" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        TOTAL RECORDS
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="file-text"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#0061a5",
                          padding: 10,
                          background: "#d7e0e9",
                          borderRadius: 10,
                        }}
                      />
                    </Col>
                    <Col span={24}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0 }}
                      >
                        {this.state.totalRecords}
                      </Typography.Title>
                      <Typography.Text style={{ fontSize: 12 }}>
                        Ready for processing
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #c4c6cf",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="middle" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        VALID ENTRIES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="check-circle"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "green",
                          padding: 10,
                          background: "#dcffd9",
                          borderRadius: 10,
                        }}
                      />
                    </Col>
                    <Col span={16}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0, color: "green" }}
                      >
                        {this.state.validRecords}
                      </Typography.Title>
                      <Typography.Text style={{ fontSize: 12 }}>
                        {!isNaN(
                          Number(this.state.validRecords) /
                            Number(this.state.totalRecords),
                        )
                          ? (
                              (Number(this.state.validRecords) /
                                Number(this.state.totalRecords)) *
                              100
                            ).toFixed(2)
                          : 0}
                        % Success Rate
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #c4c6cf",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="middle" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        WARNING CASES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="warning"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "orange",
                          padding: 10,
                          background: "#fff9d9",
                          borderRadius: 10,
                        }}
                      />
                    </Col>
                    <Col span={24}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0, color: "orange" }}
                      >
                        {this.state.warningRecords}
                      </Typography.Title>
                      <Typography.Text style={{ fontSize: 12 }}>
                        Review Recommended
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={6}>
                <Card
                  style={{
                    border: "1px solid #ffdad6",
                    borderRadius: 10,
                  }}
                >
                  <Row type="flex" align="middle" gutter={[24, 14]}>
                    <Col span={16}>
                      <Typography.Text style={{ fontWeight: 650 }}>
                        INVALID ENTRIES
                      </Typography.Text>
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <Icon
                        type="exclamation-circle"
                        style={{
                          fontSize: 20,
                          fontWeight: 700,
                          color: "#ba1a1a",
                          padding: 10,
                          background: "#f7d1d1",
                          borderRadius: 10,
                        }}
                        theme="filled"
                      />
                    </Col>
                    <Col span={24}>
                      <Typography.Title
                        level={2}
                        style={{ fontWeight: 700, margin: 0, color: "#ba1a1a" }}
                      >
                        {this.state.invalidRecords}
                      </Typography.Title>
                      <Typography.Text
                        style={{ fontSize: 12, color: "#ba1a1a" }}
                      >
                        Action Required to Proceed
                      </Typography.Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
            <Table
              columns={[
                {
                  title: "ROW",
                  dataIndex: "row",
                  render: (text) => (
                    <Typography.Title level={4}>#{text}</Typography.Title>
                  ),
                },
                {
                  title: "TYPE",
                  dataIndex: "type",
                  render: (type) => (
                    <Tag
                      color={type === "ERROR" ? "red" : "orange"}
                      style={{ border: 0, paddingInline: 10, borderRadius: 10 }}
                    >
                      <Icon
                        type={type === "ERROR" ? "close-circle" : "warning"}
                      />{" "}
                      {type}
                    </Tag>
                  ),
                },
                {
                  title: "FIELD CONTEXT ",
                  dataIndex: "context",
                },
                {
                  title: "VALIDATION MESSAGE",
                  dataIndex: "message",
                },
              ]}
              style={{ border: "1px solid #d9d9d9", borderRadius: 10 }}
              dataSource={this.state.tableData}
              rowClassName={(record) =>
                record.type === "ERROR" ? "error-row" : "warning-row"
              }
              title={() => {
                return (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography.Title level={4} style={{ paddingLeft: 20 }}>
                      DETAILED VALIDATION LOGS{" "}
                    </Typography.Title>
                    <div style={{ paddingRight: 10 }}>
                      <Typography.Text
                        style={{
                          color: "#ba1a1a",
                          background: "#fff",
                          border: "1px solid #c4c6cf",
                          borderRadius: 20,
                          paddingInline: 10,
                          paddingBlock: 5,
                        }}
                      >
                        <Badge color="#ba1a1a" />
                        Errors ({this.state.invalidRecords})
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          color: "orange",
                          background: "#fff",
                          border: "1px solid #c4c6cf",
                          borderRadius: 20,
                          paddingInline: 10,
                          paddingBlock: 5,
                        }}
                      >
                        <Badge color="orange" />
                        Warnings ({this.state.warningRecords})
                      </Typography.Text>
                    </div>
                  </div>
                );
              }}
            />
          </div>
        )}
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setScreenType: (type) => dispatch(setScreenType(type)),
    setEntryNo: (num) => dispatch(setEntryNo(num)),
    setBranchName: (name) => dispatch(setBranchName(name)),
  };
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screenName: selectScreenName,
  screenType: selectScreenType,
  uploadfile: selectUploadFile,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulkUploadSummary),
);
